import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface TitleProps {
    noColours?: boolean;
    splitLines?: boolean;
}

export const Title = ({ noColours = false, splitLines = false }: TitleProps) => {
    const { t } = useTranslation();

    const siteTitle = useMemo(() => {
        return (
            <>
                <span className={noColours ? "text-white" : "text-brandGreen"}>{t('main.title.green')}</span>
                <span className={noColours ? "text-white" : "text-brandBlue"}>{t('main.title.blue')}</span>
            </>
        )
    }, [noColours, splitLines])

    return (
        <>
            {splitLines ? (<>
                <div>
                    {siteTitle}
                </div>

                <span> {t('main.title.default')}</span>
            </>) : (
                <>
                    {siteTitle}
                    <span> {t('main.title.default')}</span>
                </>
            )}

        </>
    )
}